import { Option } from '@byecode/ui'

export const repeatModeOptions: Option[] = [
    {
        label: '跳过',
        value: 'skip',
        describe: '根据“依据字段”的内容，如果在工作表中已经存在，则直接跳过这一行， 如果没有作为新数据新记录导入。'
    },
    {
        label: '覆盖',
        value: 'cover',
        describe: '将Excel的数据完全覆盖到工作表，如果识别到工作表中已经有了相同的记录，就更新这行记录，如果没有就作为新记录导入。'
    },
    {
        label: '仅更新，不新增记录',
        value: 'update',
        describe: '导入时只更新已有记录，即使Excel中有些行数据不在工作表，也不导入新的记录。'
    }
]
